import * as Blockly from 'blockly/core'

const SPRITE_OPTIONS = [
  ['kiko', 'kiko'],
  ['apel', 'apel'],
  ['batu', 'batu'],
]

export function registerLooksBlocks() {
  Blockly.common.defineBlocksWithJsonArray([
    {
      type: 'looks_show',
      message0: '👁️ tampilkan %1',
      args0: [{ type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS }],
      previousStatement: null,
      nextStatement: null,
      colour: 270,
      tooltip: 'Tampilkan sprite',
    },
    {
      type: 'looks_hide',
      message0: '🙈 sembunyikan %1',
      args0: [{ type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS }],
      previousStatement: null,
      nextStatement: null,
      colour: 270,
      tooltip: 'Sembunyikan sprite',
    },
    {
      type: 'looks_scale',
      message0: '🎨 ubah ukuran %1 ke %2 %',
      args0: [
        { type: 'field_dropdown', name: 'SPRITE', options: SPRITE_OPTIONS },
        { type: 'field_number', name: 'SCALE', value: 50, min: 10, max: 200 },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: 270,
      tooltip: 'Ubah ukuran sprite (persen)',
    },
    {
      type: 'looks_say',
      message0: '💬 katakan %1 selama %2 detik',
      args0: [
        { type: 'field_input', name: 'TEXT', text: 'Halo!' },
        { type: 'field_number', name: 'SECONDS', value: 2, min: 0.1, max: 10, precision: 0.1 },
      ],
      previousStatement: null,
      nextStatement: null,
      colour: 270,
      tooltip: 'Tampilkan speech bubble dengan teks selama N detik',
    },
  ])
}
